import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { IEGTextRun } from '@tencent/slide-sdk-model';
import { isLatinLang } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/language';
import { ITextRun } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import { TextRunStyleConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/text/text-run/text-run-style-converter';

/**
 * 文字属性
 */
export class TextRunConverter {
    /**
     * 文字属性的sdk -> ui 映射
     * @param sdkTextRun
     */
    public static convertPartialDataFromSdkToUi(sdkTextRun?:
    DeepReadonly<DeepPartial<IEGTextRun>>): ITextRun[] | undefined {
        // 软回车
        if (sdkTextRun?.br) {
            const uiTextRun = {
                text: '\n',
                type: 'runBr',
                styles: {},
            };
            // 通用样式
            const rPr = (sdkTextRun.br)?.rPr;
            if (rPr) {
                TextRunStyleConverter.convertPartialDataFromSdkToUi(rPr, uiTextRun.styles);
            }
            return [uiTextRun];
        }

        // 普通文字 - r    ||     （slideNum | 日期） - fld
        if (sdkTextRun?.r || sdkTextRun?.fld) {
            return TextRunConverter.splitTextByLanguage(sdkTextRun).map((text) => {
                const uiTextRun: any = {
                    text,
                    type: sdkTextRun.fld ? 'field' : 'run',
                    styles: {},
                };

                // 通用样式
                const rPr = (sdkTextRun.fld || sdkTextRun.r)?.rPr;
                if (rPr) {
                    TextRunStyleConverter.convertPartialDataFromSdkToUi(rPr, uiTextRun.styles);
                }

                // slideNum | 日期
                if (sdkTextRun.fld) {
                    uiTextRun.fieldType = sdkTextRun.fld.type;
                    uiTextRun.fieldId = sdkTextRun.fld.id;
                }
                return uiTextRun;
            });
        }
    }

    /**
     * 文字属性的ui -> sdk 映射
     * @param uiTextRun
     */
    public static convertPartialDataFromUiToSdk(uiTextRun?:
    DeepReadonly<DeepPartial<ITextRun>>): IEGTextRun[] | undefined {
        const rPr = {};
        if (uiTextRun?.styles) {
            TextRunStyleConverter.convertPartialDataFromUiToSdk(uiTextRun.styles, rPr);
        }
        // 软回车
        if (uiTextRun?.type === 'runBr') {
            return [{
                br: {
                    rPr,
                },
            }];
        }
        // （slideNum | 日期） - fld
        if (uiTextRun?.type === 'field') {
            return [{
                fld: {
                    id: uiTextRun.fieldId,
                    type: uiTextRun.fieldType,
                    t: uiTextRun.text,
                    rPr,
                },
            }];
        }
        // 普通文字 - r
        if (uiTextRun) {
            return [{
                r: {
                    t: uiTextRun.text,
                    rPr,
                },
            }];
        }
    }

    /**
     * 将文本按中英文拆分
     * @param textRun
     * @private
     */
    // eslint-disable-next-line complexity
    private static splitTextByLanguage(textRun: DeepReadonly<DeepPartial<IEGTextRun>>): string[] {
        if (textRun.fld) {
            // slideNum或者日期 不拆分
            return [textRun.fld.t || ''];
        }
        if (textRun.r?.rPr?.hlinkClick?.id) {
            // 链接 不拆分
            return [textRun.r.t || ''];
        }
        // ea latin 字体不一样
        const isEaLatinTypefaceDifferent = textRun.r?.rPr?.ea?.typeface && textRun.r?.rPr?.latin?.typeface
                && (textRun.r.rPr.ea.typeface !== textRun.r?.rPr?.latin?.typeface);
        if (!isEaLatinTypefaceDifferent) {
            // 中英文字体一致，不拆分
            return [textRun?.r?.t || ''];
        }
        // 其余情况按中英文拆分
        const text = textRun?.r?.t;
        if (!text) {
            return [''];
        }
        const splitArr: string[] = [];
        let isLatinFlag: any = null;
        let tempRun = '';
        for (let i = 0; i < text.length; i++) {
            const isLatin = isLatinLang(text[i]);
            if (isLatinFlag === null) {
                isLatinFlag = isLatin; // 第一次
                tempRun += text[i];
            } else {
                if (isLatinFlag === isLatin) {
                    tempRun += text[i];
                } else {
                    splitArr.push(tempRun);
                    isLatinFlag = isLatin; // 更新本次run的语言
                    tempRun = text[i]; // 重制tmpRun
                }
            }
            if (i === text.length - 1) {
                splitArr.push(tempRun);
            }
        }
        return splitArr;
    }
}
